import Card from "components/card";
import axios from "axios";
import {useUserAuth} from "../../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";
import React, {useState} from "react";

const Delete = (props) => {
    let {image, productId, category, subCategory, name, mfg, def} = props;

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/LAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";

    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState("");
    let productImage = 0, addDp = 0, deleteDp = 0, changeDp = 0

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            //console.log(error.message);
        }
    }

    function checkForChange() {
        if (sessionStorage.getItem("uploadedImageFileName") !== "" || sessionStorage.getItem("uploadedImageFileName") !== null) {
            productImage = 1
            updateProductInformation()
        }

        if (sessionStorage.getItem("addedDps") !== "" && sessionStorage.getItem("addedDps") !== null) {
            addDp = 1
            addProductDp()
        }

        if (sessionStorage.getItem("changedDps") !== "" && sessionStorage.getItem("changedDps") !== null) {
            updateProductDp()
        }

        if (JSON.parse(sessionStorage.getItem("deletedDps")) !== "" && JSON.parse(sessionStorage.getItem("deletedDps")) !== null) {
            deleteProductDp()
        }
    }

    async function updateProductInformation() {
        //console.log(sessionStorage.getItem("updatedProductImageName"))
        if (sessionStorage.getItem("updatedProductImageName") === "" || sessionStorage.getItem("updatedProductImageName") === null) {
            //console.log(JSON.parse(sessionStorage.getItem("changedDps")))
            setErrorMessage("No changes done. There is nothing to be saved..")
        } else {

            setErrorMessage("")
            let productCatalogInfo = {
                productId: productId, product: name, mfg: mfg, unit: category, category: subCategory
            }

            let productImage = sessionStorage.getItem("updatedProductImage")


            //console.log("Updated Product Info Image:", updatedProductInfoImage)
            const bodyFormData = new FormData();
            //let blob

            const json = JSON.stringify(productCatalogInfo);
            const jsonBlob = new Blob([json], {
                type: 'application/json'
            });

            const byteString = atob(productImage.split(',')[1]); // Strip off the data URL header
            const mimeString = productImage.split(',')[0].split(':')[1].split(';')[0];
            const arrayBuffer = new ArrayBuffer(byteString.length);
            const uintArray = new Uint8Array(arrayBuffer);

            for (let i = 0; i < byteString.length; i++) {
                uintArray[i] = byteString.charCodeAt(i);
            }

            const file = new File([arrayBuffer], 'uploaded_image', {type: mimeString});

            bodyFormData.append("productCatalogInfo", jsonBlob)
            bodyFormData.append("fileImage", file);

            //console.log(pid)
            var url = CROMPTON_URL + "product/update/productImage/" + productId
            await axios.post(url, bodyFormData, {
                headers: {
                    "Content-Type": "multipart/form-data", Authorization: decryptedValue
                },
            }).then((response) => {
                //console.log(response)
                sessionStorage.removeItem("updatedProductImageName")
                sessionStorage.removeItem("updatedProductImage")
                sessionStorage.removeItem("uploadedImageFilename")
                sessionStorage.removeItem("uploadedImageFile")
                window.location.reload()
            }).catch((error) => {
                setErrorMessage("Error updating image")
                sessionStorage.removeItem("updatedProductImageName")
                sessionStorage.removeItem("updatedProductImage")
                sessionStorage.removeItem("uploadedImageFilename")
                sessionStorage.removeItem("uploadedImageFile")

                //setErrorMessage(error.response.data.message)
                //console.log(error);
                if (error.response.data.status === "401" || error.response.data.status === "403") {
                    handleLogOut();
                }
            })
        }
    }

    async function addProductDp() {
        //console.log(sessionStorage.getItem("addedDps"))
        if (sessionStorage.getItem("addedDps") === "" || sessionStorage.getItem("addedDps") === null) {
            //console.log(JSON.parse(sessionStorage.getItem("addedDps")))
            setErrorMessage("No changes done. There is nothing to be saved..")
        } else {

            setErrorMessage("")
            let productCatalogInfo = {
                productId: productId, dpIds: sessionStorage.getItem("addedDps")
            }


            //console.log(pid)
            var url = CROMPTON_URL + "product/add/productDpInfos"
            axios({
                method: 'post',
                url: url,
                data: productCatalogInfo,
                headers: {
                    Authorization: decryptedValue,
                }

            }).then(response => {
                sessionStorage.removeItem("addedDps")
                //console.log(response)
                window.location.reload()
            })
                .catch(
                    error => {
                        setErrorMessage("Error updating image")

                        //setErrorMessage(error.response.data.message)
                        //console.log(error);
                        if (error.response.data.status === "401" || error.response.data.status === "403") {
                            handleLogOut();
                        }
                    })
        }


    }

    async function updateProductDp() {
        //console.log(sessionStorage.getItem("addedDps"))
        if (sessionStorage.getItem("changedDps") === "" || sessionStorage.getItem("changedDps") === null) {
            //console.log(JSON.parse(sessionStorage.getItem("addedDps")))
            setErrorMessage("No changes done. There is nothing to be saved..")
        } else {

            setErrorMessage("")

            // console.log(JSON.parse(sessionStorage.getItem("changedDps")))
            var url = CROMPTON_URL + "product/update/productDpInfos"
            axios({
                method: 'put',
                url: url,
                data: JSON.parse(sessionStorage.getItem("changedDps")),
                headers: {
                    Authorization: decryptedValue,
                }

            }).then(response => {
                //console.log(response)
                sessionStorage.removeItem("changedDps")
                //console.log(response)
                window.location.reload()
            })
                .catch(
                    error => {

                        setErrorMessage("Error updating data points")

                        //setErrorMessage(error.response.data.message)
                        //console.log(error);
                        if (error.response.data.status === "401" || error.response.data.status === "403") {
                            handleLogOut();
                        }
                    })
        }


    }

    async function deleteProductDp() {
        //console.log(sessionStorage.getItem("addedDps"))
        if (JSON.parse(sessionStorage.getItem("deletedDps")) === "" && JSON.parse(sessionStorage.getItem("deletedDps")) === null) {
            //  console.log(JSON.parse(sessionStorage.getItem("deletedDps")))
            setErrorMessage("No changes done. There is nothing to be saved..")
        } else {

            setErrorMessage("")
            //
            //console.log(JSON.parse(sessionStorage.getItem("deletedDps")))
            var url = CROMPTON_URL + "product/delete/productDpInfos"
            axios({
                method: 'delete',
                url: url,
                data: JSON.parse(sessionStorage.getItem("deletedDps")),
                headers: {
                    Authorization: decryptedValue,
                }

            }).then(response => {
                // console.log(response)
                sessionStorage.removeItem("deletedDps")
                //console.log(response)
                window.location.reload()
            })
                .catch(
                    error => {
                        sessionStorage.removeItem("deletedDps")
                        setErrorMessage("Error deleting Data Points")

                        //setErrorMessage(error.response.data.message)
                        // console.log(error);
                        if (error.response.data.status === "401" || error.response.data.status === "403") {
                            handleLogOut();
                        }
                    })
        }


    }

    function enableDisableProduct(def) {
        setErrorMessage("")
        //
        //console.log(JSON.parse(sessionStorage.getItem("deletedDps")))
        var url = CROMPTON_URL + "product/update/productCatalog"
        var params = {
            productId: productId,
            product: name,
            def: def
        }
        axios({
            method: 'post',
            url: url,
            data: params,
            headers: {
                Authorization: decryptedValue,
            }

        }).then(response => {
             //console.log(response)
            //sessionStorage.removeItem("deletedDps")
            //console.log(response)
            navigate("/admin/products/products-overview")
            //window.location.href = "/admin/products/products-overview"
        })
            .catch(
                error => {
                    setErrorMessage("Error deleting Data Points")

                    //setErrorMessage(error.response.data.message)
                    //console.log(error);
                    if (error.response.data.status === "401" || error.response.data.status === "403") {
                        handleLogOut();
                    }
                })
    }


    return (
        <Card extra="gap-4 rounded-[20px] px-[28px] py-[50px]">
            <div>
                <span className="errorMessage items-center flex justify-content: center align-items: center flex-col">
                    {errorMessage}
                </span>
            </div>
            <div className="ml-auto flex flex-col items-center gap-4 md:flex-row">
                {def.toString() === "1" &&
                    <button onClick={() => enableDisableProduct(0)}
                        className="rounded-xl border-2 border-red-500 bg-none px-10 py-2 text-base font-medium text-red-500 hover:bg-red-50">
                        Disable Product
                    </button>
                }
                {def.toString() !== "1" &&
                    <button onClick={() => enableDisableProduct(1)}
                        className="rounded-xl border-2 border-green-500 bg-none px-10 py-2 text-base font-medium text-green-500 hover:bg-green-50">
                        Enable Product
                    </button>
                }
                <button onClick={checkForChange}
                        className="rounded-xl bg-[#004c86] px-10 py-2 text-base font-medium text-white transition duration-200 hover:bg-[#004c86]  active:bg-[#004c86]  dark:bg-[#004c86]  dark:text-white dark:hover:bg-[#004c86]  dark:active:bg-[#004c86] ">
                    Save Changes
                </button>
            </div>
        </Card>
    );
};

export default Delete;
